<header class="topbar" [class]="isMobileNav ? 'mobile-header' : ''">
  <nav class="navbar top-navbar navbar-expand-md">
    <!-- <button type="button" (click)="toogleNav()"><i [class]="isNavOpen ? 'fa fa-angle-left' : 'fa fa-angle-right'"></i></button> -->

    <ng-container *ngIf="isNavOpen; else showMainLogo">
      <button type="button" class="expand-menu" (click)="toogleNav()">
        <i class="icon-menu-expand"></i>
      </button>
    </ng-container>
    <ng-template #showMainLogo>
      <img
        src="assets/images/sft-travel-desk.svg"
        alt="homepage"
        class="light-logo"
        style="filter: brightness(0.5)"
      />
    </ng-template>
    <!-- <div class="navbar-header"> -->
    <!-- ============================================================== -->
    <!-- Logo -->
    <!-- ============================================================== -->
    <!-- <a class="navbar-brand" [class]="isNavOpen ? 'open' : 'close'">
        @if(isMobileNav){
        <button
          [class]="isMobileNavOpen ? 'mobile-nav-margin' : ''"
          mat-icon-button
          (click)="toogleMobileMenu()"
        >
          <mat-icon>{{ isMobileNavOpen ? "close" : "menu" }}</mat-icon>
        </button>
        } @else {
        @if (isNavOpen) {

        <span class="logo-text ms-5" routerLink="/">
          <img src="assets/images/logo.png" alt="homepage" class="light-logo" />
        </span>
        } @if (!isNavOpen) {
        <b class="logo-icon ps-2" routerLink="/">
          <img
            src="assets/images/logo-tiny.svg"
            class="img-fluid"
            alt="homepage"
            class="light-logo"
            width="25"
          />
        </b>
        } }
      </a> -->

    <!-- <a class="navbar-brand" [class]="isNavOpen ? 'open' : 'close'">
        @if(isMobileNav){
        <button
          [class]="isMobileNavOpen ? 'mobile-nav-margin' : ''"
          mat-icon-button
          (click)="toogleMobileMenu()"
        >
          <mat-icon>{{ isMobileNavOpen ? "close" : "menu" }}</mat-icon>
        </button>
        } @else {
         }
      </a> -->

    <!-- <a
        class="nav-toggler waves-effect waves-light d-block d-md-none"
        href="javascript:void(0)"
        (click)="toogleNav()"
      >
        <mat-icon>menu</mat-icon>
      </a> -->
    <!-- </div> -->
    <div id="navbarSupportedContent" data-navbarbg="skin5">
      <!-- <ul class="navbar-nav float-start me-auto">
        <li class="nav-item d-none d-lg-block">
          <a
            class="nav-link sidebartoggler waves-effect waves-light"
            href="javascript:void(0)"
            (click)="toogleNav()"
          >
            <mat-icon>menu</mat-icon></a
          >
        </li>
      </ul> -->
      <!-- <div class="scroll-left">
        <p>
          <b>For Flight : </b> Cancel your ticket 4 hours prior to the scheduled
          departure time. <b> For Train : </b> You have to contact Travel Desk .
        </p>
      </div> -->

      <!-- ============================================================== -->
      <!-- Right side toggle and nav items -->
      <!-- ============================================================== -->
      <ul class="header-right-action">
        <li
          class=""
          *ngIf="permissions.hasPermission(claims, 'SETT_ADD_CONTACT_SUPPORT')"
        >
          <a
            class="dropdown-toggle btn-header-icon pointer"
            (click)="
              navService.openSideNav({
                toogle: true,
                activity: 'contact-support',
              })
            "
          >
            <mat-icon>help</mat-icon>
          </a>
        </li>
        <li class="">
          <a
            class="dropdown-toggle btn-header-icon"
            (click)="
              navService.openSideNav({
                toogle: true,
                activity: 'notifications',
              })
            "
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="icon-bell"></i>
            <span *ngIf="count?.unreadCount"></span>
            <!-- <span *ngIf="count?.unreadCount">{{
              count?.unreadCount ?? 0
            }}</span> -->
          </a>
        </li>

        <!-- ============================================================== -->
        <!-- User profile and search -->
        <!-- ============================================================== -->
        <li>
          <a
            class="dropdown-toggle btn-profile"
            [matMenuTriggerFor]="matMenu"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            (click)="assignedEmployeeCount()"
          >
            <span class="pp-image-holder">{{
              userDetails?.name.charAt(0)
            }}</span>
            <div class="profile-info">
              <p>{{ userDetails?.name }}</p>
              <span>{{
                userDetails?.userRoles?.length
                  ? userDetails?.userRoles[0]?.name
                  : ""
              }}</span>
            </div>
          </a>

          <mat-menu
            #matMenu="matMenu"
            yPosition="below"
            class="user-profile-wrap"
          >
            <div class="btn-profile">
              <div class="pp-image-holder">
                {{ userDetails?.name.charAt(0) }}
              </div>
              <div class="profile-info">
                <p>{{ userDetails?.name }}</p>
                <span>{{ userDetails?.email }}</span>
              </div>
            </div>
            <div class="user-box" *ngIf="assignedEmployee">
              <p>
                <span><i class="icon-group"></i>&nbsp;Assigned to Me</span>
                <a
                  role="button"
                  class="assigned-employee-link"
                  (click)="openTeamList()"
                  >{{ assignedEmployee }} Employee{{
                    assignedEmployee > 1 ? "s" : ""
                  }}</a
                >
              </p>
              <span></span>
              <p></p>
            </div>
            <div class="profile-menu-wrap">
              <button routerLink="/settings/my-account">
                My Account
              </button>
              <!-- <button
                (click)="
                  navService.openSideNav({
                    toogle: true,
                    activity: 'change-password',
                  })
                "
              >
                Change Password
              </button> -->
              <button
                (click)="
                  navService.openSideNav({
                    toogle: true,
                    activity: 'help-and-support',
                  })
                "
              >
                Help & Support
              </button>
              <button
                (click)="
                  navService.openSideNav({
                    toogle: true,
                    activity: 'request-a-call',
                  })
                "
              >
                Request a call
              </button>
              <button *ngIf="permissions.hasPermission(claims, 'SETT_ADD_CONTACT_SUPPORT')"
                (click)="
                  navService.openSideNav({
                    toogle: true,
                    activity: 'contact-support',
                  })
                "
              >
                Contact Support
              </button>
              <button (click)="downloadUserManual()">
                Download User Manual
              </button>
              <button class="danger" (click)="signOut()">Sign Out</button>
            </div>

            <div class="scan-box">
              <p>Scan to Download Mobile App</p>
              <div class="app-dwnld-box">
                <div class="andrd-box">
                  <div class="qr-img">
                    <img
                      src="/assets/images/ANDROID-QR.png"
                      alt=""
                    />
                  </div>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.travel.sfdesk"
                    target="_blank"
                    class="btm-box"
                  >
                    <img src="/assets/images/playstore.png" alt="" />
                    <p>Google Play Store</p>
                  </a>
                </div>

                <div class="andrd-box">
                  <div class="qr-img">
                    <img
                      src="/assets/images/IOS-APP-QR.png"
                      alt=""
                    />
                  </div>
                  <a
                    href="https://apps.apple.com/in/app/sftravel-desk/id6593685111"
                    target="_blank"
                    class="btm-box"
                  >
                    <img src="/assets/images/app-store.png" alt="" />
                    <p>App Store</p>
                  </a>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
      </ul>
    </div>
  </nav>
</header>
